"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiographicsLookupToJSON = exports.BiographicsLookupFromJSONTyped = exports.BiographicsLookupFromJSON = void 0;
const runtime_1 = require("../runtime");
function BiographicsLookupFromJSON(json) {
    return BiographicsLookupFromJSONTyped(json, false);
}
exports.BiographicsLookupFromJSON = BiographicsLookupFromJSON;
function BiographicsLookupFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'middleName': !runtime_1.exists(json, 'middleName') ? undefined : json['middleName'],
        'noMiddleName': json['noMiddleName'],
        'lastName': json['lastName'],
        'dob': (new Date(json['dob'])),
        'countryOfBirth': json['countryOfBirth'],
        'phoneNumber': !runtime_1.exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'emailAddress': !runtime_1.exists(json, 'emailAddress') ? undefined : json['emailAddress'],
    };
}
exports.BiographicsLookupFromJSONTyped = BiographicsLookupFromJSONTyped;
function BiographicsLookupToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstName': value.firstName,
        'middleName': value.middleName,
        'noMiddleName': value.noMiddleName,
        'lastName': value.lastName,
        'dob': (value.dob.toISOString().substr(0, 10)),
        'countryOfBirth': value.countryOfBirth,
        'phoneNumber': value.phoneNumber,
        'emailAddress': value.emailAddress,
    };
}
exports.BiographicsLookupToJSON = BiographicsLookupToJSON;
//# sourceMappingURL=BiographicsLookup.js.map